import { render } from "./customDishesModel.vue?vue&type=template&id=6a87afa6"
import script from "./customDishesModel.vue?vue&type=script&lang=js"
export * from "./customDishesModel.vue?vue&type=script&lang=js"

import "./customDishesModel.vue?vue&type=style&index=0&id=6a87afa6&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__